module.exports = __webpack_public_path__ + "static/media/fa-regular-400.1b846087.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-regular-400.woff2
// module id = 737
// module chunks = 0